import { isMockUsed } from '@nvision/services/mock';

import { ROUTES as CONTRACTS_ROUTES } from '@/modules/contracts-management';
import { ROUTES as PRICING_ROUTES } from '@/modules/pricing';
import { ROUTES as PROCUREMENT_ROUTES } from '@/modules/procurement';

export const AUTH_ROUTES = {
  LOGIN: '/',
} as const;

export const APP_ROUTES = {
  ADD_LANE: '/procurement/route-config/lane/add',
  ADD_NXP_USER: '/routing-guide/add-user',
  ADD_PROJECT_PROCUREMENT: '/procurement/add-project',
  ADD_ROUTING_GUIDE: '/routing-guide/add-routing-guide',
  ADD_SHIPMENT: '/shipment/add',
  ADD_TENDER_PROCUREMENT: '/procurement/add-tender',
  ADDRESS_BOOK: '/shipment/address-book',
  AUCTION: '/auction',
  CARRIER_REGISTRATION: '/CarrierRegistration',
  CarrQuoteDashboard: '/CarrQuoteDashboard',
  CLAIMS: '/claims',
  CLAIMS_REPORTS: '/claims/reports',
  CLAIMS_SETTINGS: '/claims/settings',
  CREATE_LOSS_AND_DAMAGE_CLAIMS: '/claims/loss-damage/create',
  CREATE_SHIPMENT: '/create-shipment',
  CREATE_SHIPMENT_ID: '/create-shipment/:shipmentKey',
  DASHBOARD: '/dashboard',
  ERROR: '/error',
  HAL_ROUTING_GUIDE: '/Hal-routing-guide',
  HOME: '/',
  LOSS_AND_DAMAGE_CLAIMS: '/claims/loss-damage',
  NXP_ROUTING_GUIDE: '/routing-guide/nxp',
  OVERCHARGE_CLAIMS: '/claims/over-charge',
  OVERCHARGE_CLAIMS_CREATE: '/claims/over-charge/create',
  PRE_CLAIMS: '/claims/pre',
  PROCUREMENT: '/procurement',
  PROCUREMENT_BID_ANALYSIS: '/procurement/bid-analysis',
  PROCUREMENT_PROJECT: '/procurement/project',
  PROCUREMENT_ROUTE_CONFIG: '/procurement/route-config',
  PROCUREMENT_ROUTE_CONFIG_LOCATION: '/procurement/route-config/location',
  PROCUREMENT_TENDER: '/procurement/tender',
  PURCHASE_ORDER_DRAFT_SEARCH: '/purchase-order-management/draft-search',
  PURCHASE_ORDER_MANAGEMENT: '/purchase-order-management',
  PURCHASE_ORDER_MANAGEMENT_ID: '/purchase-order-management/:shipmentKey',
  PURCHASE_ORDER_PARCEL_EXPRESS: '/parcel-express/:shipmentNumber',
  PURCHASE_ORDER_PRE_BOOKING_SEARCH: '/purchase-order-management/pre-booking-search',
  PURCHASE_ORDER_ROUTING_GUIDE: '/purchase-order-management/routing-guide',
  PURCHASE_ORDER_SHIPMENT_SEARCH: '/purchase-order-management/shipment-search',
  PURCHASE_ORDER_VENDOR_SEARCH: '/purchase-order-management/vendor-search',
  PURCHASE_ORDER_VIEW: '/purchase-order-view',
  QUOTE_DETAILS: '/quotedetails',

  RATE_SHOP: '/rate-shop',
  ROUTING_GUIDE: '/routing-guide',
  ROUTING_GUIDE_USER: '/routing-guide/user',
  SAVERS: '/savers',
  SAVERS_HOME: '/savers/savers-home',

  SAVERS_HOME_MAIN: '/savers-home',
  SAVERS_LOCATIONS: '/savers/locations',
  SAVERS_LOCATIONS_MAIN: '/locations',
  SAVERS_SHIPMENT: '/savers/saver-shipment',
  SAVERS_SUPPLYZONE: '/savers/supply-zone',
  SAVERS_SUPPLYZONE_MAIN: '/supply-zone',
  SAVERS_TRAILERDATABASE: '/savers/trailer-database',
  SAVERS_TRAILERDATABASE_MAIN: '/trailer-database',
  SEARCH_QUOTE: '/search-quote',
  SEARCH_QUOTE_CREATE: '/search-quote/create',
  SEARCH_QUOTE_GET_RATE: '/search-quote/get-rate',
  SEARCH_QUOTE_ID: '/search-quote/:quoteKey',
  SEARCH_QUOTE_ID_HISTORY: '/search-quote/:quoteKey/history',
  SETTINGS: '/settings',
  SHIPMENT: '/shipment',
  SHIPMENT_GET_QUOTE: '/shipment/get-quote',
  SHIPMENT_GET_QUOTE_FOR_MAIN: '/get-quote',
  SHIPMENT_NOTIFICATION_ROUTING: '/shipment/notification-routing',
  SHIPMENT_PARCEL_EXPRESS: '/shipment/parcel-express',
  SHIPMENT_SEARCH_QUOTE: '/shipment/search-quote',
  TMS_SETTINGS: '/settings/tms-settings',
  VISIBILITY: '/visibility',
} as const;

export const API_APP_ROUTES = {
  Auction: APP_ROUTES.AUCTION,
  BidAnalysis: APP_ROUTES.PROCUREMENT_BID_ANALYSIS,
  CarrierRegistration: APP_ROUTES.CARRIER_REGISTRATION,
  CarrQuoteDashboard: APP_ROUTES.CarrQuoteDashboard,
  Dashboard: APP_ROUTES.DASHBOARD,
  GetQuote: APP_ROUTES.QUOTE_DETAILS,
  iClaims: APP_ROUTES.LOSS_AND_DAMAGE_CLAIMS,
  iProcurement: APP_ROUTES.PROCUREMENT,
  iShipment: APP_ROUTES.SHIPMENT,
  iVisibility: APP_ROUTES.VISIBILITY,
  'iVisibility for Cust': APP_ROUTES.VISIBILITY,
  PO: APP_ROUTES.PURCHASE_ORDER_VIEW,
  POV: APP_ROUTES.PURCHASE_ORDER_MANAGEMENT,

  ...(isMockUsed() && {
    'Contract Management': CONTRACTS_ROUTES.index(),
    Pricing: PRICING_ROUTES.index(),
    'Procurement New': PROCUREMENT_ROUTES.index(),
  }),

  ProcurementProject: APP_ROUTES.PROCUREMENT,
  ProcurementTender: APP_ROUTES.PROCUREMENT_TENDER,
  QuoteDashboard: APP_ROUTES.DASHBOARD,
  QuoteRoutingGuide: APP_ROUTES.HAL_ROUTING_GUIDE,
  RateShop: APP_ROUTES.RATE_SHOP,
  RouteConfiguration: APP_ROUTES.PROCUREMENT_ROUTE_CONFIG,
  RoutingGuide: APP_ROUTES.ROUTING_GUIDE,
  RoutingGuideHome: APP_ROUTES.NXP_ROUTING_GUIDE,
  RoutingGuideUser: APP_ROUTES.ROUTING_GUIDE_USER,
  SearchQuote: APP_ROUTES.SEARCH_QUOTE,
  SearchQuoteId: APP_ROUTES.SEARCH_QUOTE_ID,
  Settings: APP_ROUTES.SETTINGS,
  ShipmentGetQuote: APP_ROUTES.SHIPMENT_GET_QUOTE_FOR_MAIN,
  TMSSettings: APP_ROUTES.TMS_SETTINGS,
  TrailerManagement: APP_ROUTES.SAVERS,
  'Visibility for Vendor': APP_ROUTES.VISIBILITY,
} as const;

export const ACTION_NEEDED_ROUTES = {
  BASE: '/action-needed',
  SHIPMENT_APPROVAL_REJECTION: '/shipment/approval-rejection',
} as const;
